<template>
  <div
    class="city-places-slider"
    :class="{
      'no-slides': !loading && !places.length,
      'slim-slider': slimSlider,
    }"
  >
    <Loader :loading="loading" />
    <Slider v-if="places && places.length" classes="size-4">
      <PlaceCard
        v-for="(place, index) of places"
        :key="`${place.id}-${index}`"
        :slim-slider="slimSlider"
        :place="place"
      />
    </Slider>
  </div>
</template>

<script>
import Slider from 'Components/Slider.vue';
import PlaceCard from 'Components/PlaceCard.vue';
import Loader from 'Components/loader/Loader.vue';

export default {
  name: 'CityPlacesSlider',
  components: {
    Loader,
    PlaceCard,
    Slider,
  },

  data() {
    const { termId, placeTypeTerm, slimSlider } = this.$mountEl.dataset;
    const parsedPlaceTypeTerm = JSON.parse(placeTypeTerm);

    return {
      placeTypeTerm: parsedPlaceTypeTerm,
      slimSlider: !!slimSlider,
      loading: false,
      places: [],
      params: {
        location: termId,
        placeType: parsedPlaceTypeTerm.slug,
      },
    };
  },

  created() {
    this.getPlaces();
  },

  methods: {
    getPlaces() {
      this.loading = true;
      fetch(
        `${theme_vars.site_url}/wp-json/places-api/v1/places-for-city-pages?${this.parseUrlParams(this.params)}`
      )
        .then((response) => response.json())
        .then((data) => {
          const { posts: places } = data;

          this.places = places.sort((first, second) => {
            if (first.hasThumbnail) {
              return second.hasThumbnail ? 0 : -1;
            }

            return second.hasThumbnail ? 1 : 0;
          });

          this.loading = false;
        });
    },

    parseUrlParams(params) {
      return Object.keys(params)
        .map((key) => `${key}=${params[key]}`)
        .join('&');
    },
  },
};
</script>
